exports = module.exports = require("../../../../../../home/node/site/node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../home/node/site/node_modules/css-loader/index.js?minimize!./css/serp.css"), "");

// module
exports.push([module.id, "\n", ""]);

// exports
